import React from 'react';
import { Link,useHistory } from 'react-router-dom';
import swal from "sweetalert";
import axios from "axios";
import UseFullPageLoader from '../../component/FullPageLoader/UseFullPageLoader';



const Navbar = () => {

    const history = useHistory();
    const [loader, showLoader, hideLoader] = UseFullPageLoader();
    const authToken = localStorage.getItem('auth_token');
    const authName = localStorage.getItem('auth_name');
    const userId = localStorage.getItem('user_id');
    const userType = localStorage.getItem('type');

    const data = {
        auth_token: authToken,
        user_id: userId,
        auth_name: authName,
        user_type: userType,
    }

    const logoutSubmit = (e) => {
        showLoader();
        e.preventDefault();
        axios.post('/api/user/logout',data).then(res => {
            if(res.data.status_code === 200) {
                hideLoader();
                localStorage.removeItem('auth_token');
                localStorage.removeItem('auth_name');
                localStorage.removeItem('user_id');
                localStorage.removeItem('type');
                swal({ position: 'top-end', icon: 'success', title: res.data.message, showConfirmButton: false, timer: 1500 });
                history.push('/');
            } else {

            }
         }).catch(error => {
            console.log(error)
        });
    }


    const clickNavbarToggal = (e) => {
        //console.log('hiiiii');

        e.preventDefault();
        //document.body.className
        //document.body.removeAttribute('')
        //e.target.classList.contains()

        //if(e.target.document.querySelector("#page-top").classList.contains('sidebar-toggled')){

            //e.target.classList.contains('sidebar-toggled').classList.add('hiii');

          //let  element = document.getElementById("page-top");

            //document.getElementById('page-top').classList.add('hiii');
       // console.log(e.target.className);

        if(document.getElementById('page-top').classList.contains('sidebar-toggled')){
           
            document.querySelector(".sidebar").classList.remove('toggled');
            document.querySelector("#page-top").classList.remove('sidebar-toggled');
        }
        else {
            document.querySelector(".sidebar").classList.add('toggled');
            document.querySelector("#page-top").classList.add('sidebar-toggled');
        }
        
    }

    return (
        <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            <button id="sidebarToggleTop" onClick={(e) => clickNavbarToggal(e)} className="btn btn-link d-md-none rounded-circle mr-3">
                <i className="fa fa-bars"></i>
            </button>
            <ul className="navbar-nav ml-auto">
                <li className="nav-item dropdown no-arrow d-sm-none">
                    {/* <Link className="nav-link dropdown-toggle" to="#" id="searchDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i className="fas fa-search fa-fw"></i>
                    </Link> */}
                    <div className="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in" aria-labelledby="searchDropdown">
                        <form className="form-inline mr-auto w-100 navbar-search">
                            <div className="input-group">
                                <input type="text" className="form-control bg-light border-0 small" placeholder="Search for..." aria-label="Search" aria-describedby="basic-addon2" />
                                <div className="input-group-append">
                                    <button className="btn btn-primary" type="button"><i className="fas fa-search fa-sm"></i></button>
                                </div>
                            </div>
                        </form>
                    </div>
                </li>

                
                <div className="topbar-divider d-none d-sm-block"></div>

                <li className="nav-item dropdown no-arrow">

                     <Link className="nav-link dropdown-toggle" to="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span className="mr-2 d-none d-lg-inline text-gray-600 small">Admin</span>
                        <img className="img-profile rounded-circle" src={'/admin/images/user_avatar_profile.png'} alt="DirtMap"/>
                    </Link>

                    <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
                        
                                             
                        {/* <Link className="dropdown-item" to="{{ route('update_profile') }}">
                            <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                            Profile
                        </Link> */}
                        
                        <Link className="dropdown-item" to={`/admin/change-password/${localStorage.getItem('user_id')}`}>
                            <i className="fas fa-lock fa-sm fa-fw mr-2 text-gray-400"></i>
                            Change Password
                        </Link>

                        {/* <Link className="dropdown-item" to="{{ route('update_profile') }}">
                            <i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
                            Settings
                        </Link> */}

                        <div className="dropdown-divider"></div> 

                        <button onClick={logoutSubmit} className="dropdown-item" to="#" data-toggle="modal" data-target="#logoutModal">
                            <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                            Logout
                        </button>
                    </div> 
                </li>
            </ul>
            {loader}
        </nav>
    )
}
export default Navbar;